import type { CreatorEntity } from "shared/schema";
import type { AsyncValueCallback } from "shelving";
import { call, getDataKeys } from "shelving";
import { closeEventDialog } from "shared/react";
import { MEMBERS_MAX, MEMBER_ADMIN_STATUS } from "shared/schema";
import { ProfileButton } from "../entity/EntityButton.js";
import { MemberGroupPicker } from "../group/GroupPicker.js";
import { USER } from "../util/user.js";

export function CreatorPicker({ onPick, creator }: { onPick: AsyncValueCallback<CreatorEntity>; creator?: CreatorEntity | null | undefined; children?: React.ReactElement }): React.ReactElement {
	const uid = USER.data.uid;
	const profileEntity: CreatorEntity = `profile:${uid}`;
	const profileButton = (
		<button
			type="button"
			className={`input ${creator === profileEntity ? "input-active" : ""}`}
			onClick={e => {
				call(onPick, profileEntity);
				closeEventDialog(e);
			}}
		>
			<ProfileButton uid={uid} disabled mods="size-small flex-fit" />
		</button>
	);
	return (
		<>
			<h2>Choose creator</h2>
			<MemberGroupPicker //
				query={{
					uid: USER.data.uid,
					status: getDataKeys(MEMBER_ADMIN_STATUS),
					$order: "!updated",
					$limit: MEMBERS_MAX,
				}}
				onPick={gid => onPick(`group:${gid}`)}
				isPicked={gid => creator === `group:${gid}`}
				empty={profileButton}
				before={profileButton}
			/>
		</>
	);
}
